import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function FAQList({ faqs, testid = "faq" }) {
  return (
    <Accordion type="single" collapsible className="space-y-3" data-testid={testid}>
      {faqs.map((f, i) => (
        <AccordionItem key={i} value={`item-${i}`} className="card-soft !rounded-xl px-6 border">
          <AccordionTrigger data-testid={`${testid}-q-${i}`} className="text-left font-semibold text-ink hover:text-terra hover:no-underline py-5 text-base">
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-ink-soft leading-relaxed pb-5">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
